import React, { useEffect, useState } from "react";
import "./Login.css";
import {
  utilSignInWithGoogle,
  utilSignInWithEmailAndPassword,
  utilGetCollectionFilterReference,
} from "../../util/UtilsFirebase";
import AppContext from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { projectAuth } from "../../firebase/config";
import {
  isSignInWithEmailLink,
  sendPasswordResetEmail,
  signInWithEmailLink,
} from "firebase/auth";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isVisible, setVisible] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isSignInWithEmailLink(projectAuth, window.location.href)) {
      let email = window.localStorage.getItem("emailForSignIn");
      if (!email) {
        email = window.prompt("Please provide your email for confirmation");
      }
      signInWithEmailLink(projectAuth, email, window.location.href)
        .then((result) => {
          sendPasswordResetEmail(projectAuth, email).then((value) => {
            alert("Se envio un nuevo correo para asignar tu contraseña");
          });
          AppContext.user = result.user;
          window.localStorage.removeItem("emailForSignIn");
        })
        .catch((error) => {
          alert(
            "Error al validar el correo, solicite un nuevo acceso para validar.",
          );
        });
    }
  }, []);

  const handleSignIn = async () => {
    try {
      const user = await utilSignInWithEmailAndPassword(email, password);

      if (!user) {
        setErrorMessage(
          "Usuario o contraseña incorrecto. \n \nSi has iniciado sesión con Google, utiliza el botón 'Continuar con Google' para acceder a tu cuenta o utiliza la opcion 'Recuperar contraseña' para asignar una.",
        );
        setShow(true);
        return;
      }

      const registros = await utilGetCollectionFilterReference(
        "registro",
        "user",
        "==",
        user.id,
        "users",
      );

      if (!user) {
        setErrorMessage("Error de inicio de session.");
        setShow(true);
      }
      AppContext.user = user;
      AppContext.register = registros;
    } catch (error) {
      console.error(error);
      setErrorMessage(error.message);
      setShow(true);
    }
  };

  const toggle = () => {
    setVisible(!isVisible);
  };

  const handleSignInWithGoogle = async () => {
    try {
      const user = await utilSignInWithGoogle();

      console.log(user);

      AppContext.user = user;
      window.location.href = "/negocios";
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container margin-login">
      {errorMessage && show ? (
        <>
          <div
            class="alert alert-danger alert-dismissible fade show col-lg-8 col-md-10 col-sm-12 mx-auto"
            style={{ whiteSpace: "pre-line" }}
            role="alert"
          >
            <strong> {errorMessage}</strong>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              onClick={(e) => {
                setShow(false);
              }}
            ></button>
          </div>
        </>
      ) : (
        <></>
      )}
      <div className="row justify-content-center">
        <div className="col-lg-4 col-md-6 col-sm-8">
          <h2 className="text-center">Login</h2>
          <form className="container-auth">
            <div className="form-group">
              <label htmlFor="email"></label>
              <input
                name="email"
                type="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password"></label>
              <input
                name="pass"
                id="pass"
                type={!isVisible ? "password" : "text"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className=""
                onClick={toggle}
                style={{
                  alignContent: "center",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  marginLeft: "1%",
                  paddingTop: "16px",
                  paddingBottom: "13px",
                  border: "2px solid",
                }}
              >
                <i
                  className={
                    !isVisible
                      ? "bx bx-hide icon bx-sm"
                      : "bx bx-show icon bx-sm"
                  }
                  style={{ width: "12%" }}
                ></i>
              </span>
            </div>
            <div className="container-buttons">
              <button type="button" onClick={handleSignIn}>
                Iniciar sesión
              </button>
            </div>
            <div className="container-buttons2">
              <button
                type="button"
                style={{ color: "white" }}
                onClick={handleSignInWithGoogle}
              >
                Continuar con Google
              </button>
            </div>
            <br />
            <div
              className="container-buttons"
              style={{ backgroundColor: "Gray" }}
            >
              <button
                type="button"
                onClick={() => {
                  navigate("/recuperacion");
                }}
              >
                Recuperar contraseña
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
